module.exports = __webpack_public_path__ + "static/cover-f7e36fafacc6d8992f34c2ce1da6faff.png";